/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Password_ContextualInputs */

const fr_error_password_contextual = /** @type {(inputs: Error_Password_ContextualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Évitez d’utiliser votre nom ou votre adresse email dans le mot de passe.`)
};

const en_error_password_contextual = /** @type {(inputs: Error_Password_ContextualInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Avoid using your name or email address in the password.`)
};

/**
* | output |
* | --- |
* | "Avoid using your name or email address in the password." |
*
* @param {Error_Password_ContextualInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const error_password_contextual = /** @type {((inputs?: Error_Password_ContextualInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Password_ContextualInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_error_password_contextual(inputs)
	return fr_error_password_contextual(inputs)
});